<template>
    <div role="presentation">
        <div class="pa-2 bg-toolbar flex-row flex-between">
            <img class="on-contrast-force-gray self-center pointer" @click="loadInicio" :src="logo" aria-label="Logo Adaptor, autoatendimento.">
            <img v-if="showLogoAdaptor" class="on-contrast-force-gray self-center" src="../../assets/Imagens/logoAutoAtendimento.jpg" aria-label="Logo Adaptor, autoatendimento.">
        </div>

        <v-toolbar style="z-index:1; min-height: 60px;" class="bg-toolbar2 " :extended="!login && telaGrande" extension-height="10px">
            <template  #extension v-if="!login || !telaGrande">
                    <v-toolbar-items v-if="!login && telaGrande" class="container" style="margin-top:-40px; height:30px">
                            <v-btn aria-label="Início." id="btnInicio" :class="{'cl-color-white': btnSelecionado!=1}" style="border-radius: 2px" :style="[btnSelecionado===1 ? {'background-color': '#EEEEEE'} : '']" flat @click="$router.push({name: 'inicio'})"> <v-icon class="pr-2" small :class="{'corIconesToolbar': btnSelecionado===1, 'cl-color-white': btnSelecionado!=1}">fas fa-home</v-icon>Início</v-btn>
                            <v-btn aria-label="Meus Acordos." :class="{'cl-color-white': btnSelecionado!=2}" style="border-radius: 2px" :style="[btnSelecionado===2 ? {'background-color': '#EEEEEE'} : '']" flat @click="$router.push({name: 'rotas', params: {destino: '@acordos'}})"><v-icon class="pr-2" small :class="{'corIconesToolbar': btnSelecionado===2, 'cl-color-white': btnSelecionado!=2}">fas fa-file-contract</v-icon>Meus Acordos</v-btn>
                            <v-btn aria-label="Meus débitos." :class="{'cl-color-white': btnSelecionado!=3}" id="btnDebitos" style="border-radius: 2px" :style="[btnSelecionado===3 ? {'background-color': '#EEEEEE'} : '']" flat @click="$router.push({name: 'rotas', params: {destino: '@debitos'}})"><v-icon class="pr-2" :class="{'corIconesToolbar': btnSelecionado===3, 'cl-color-white': btnSelecionado!=3}" small>fas fa-money-check</v-icon>Meus débitos</v-btn>
                            <v-btn aria-label="Meus cadastro." :class="{'cl-color-white': btnSelecionado!=4}" id="btnCadastro" style="border-radius: 2px" :style="[btnSelecionado===4 ? {'background-color': '#EEEEEE'} : '']" flat @click="$router.push({name: 'rotas', params: {destino: '@cadastro'}})"><v-icon class="pr-2" :class="{'corIconesToolbar': btnSelecionado===4, 'cl-color-white': btnSelecionado!=4}" small>fas fa-address-book</v-icon>Meu cadastro</v-btn>
                            
                            <!-- <v-btn aria-label="Solicitações." style="border-radius: 2px" :style="[btnSelecionado===4 ? {'background-color': '#EEEEEE'} : '']" class="" flat ><v-icon class="pr-2 corIconesToolbar" small>fas fa-tasks</v-icon>Solicitações</v-btn> -->
                    </v-toolbar-items>
            </template>
          <!--  <div class="content-column">
                <small v-if="!telaGrande" class="mt-3 cl-color-white" style="margin-bottom: -10px">{{empresa}}</small>
            </div>-->
            <v-spacer role="presentation"></v-spacer>
            <div class="content-column pt-2">
                <div class="content-end-nowrap">
                    <div class="dropdown mr-3">
                        <button
                            aria-label="Menu de acessibilidade."
                            id="dropdownMenuLink" 
                            data-toggle="dropdown" 
                            aria-haspopup="true" 
                            aria-expanded="false"
                            >
                            <i class="fas fa-universal-access fa-lg fa-2x" style="color: #ADD8E6"></i>
                        </button>
                        <div role="menu" class="  dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuLink">
                            <a href="#" role="menuitem" class="dropdown-item" @click="mudarFonte('a')" aria-label="Aumentar fonte."><h4 class="colorLabel">A+</h4></a>
                            <div aria-hidden="true" class="dropdown-divider"></div>
                            <a href="#" role="menuitem" class="dropdown-item" @click="mudarFonte('d')" aria-label="Diminuir fonte."><h5 class="colorLabel">A-</h5></a>
                            <div aria-hidden="true" class="dropdown-divider"></div>
                            <a href="#" role="menuitem" class="dropdown-item" @click="toggleContrast()"><h6 class="colorLabel" id="altocontraste" >Contraste <i  class="fas fa-adjust pointer"></i></h6></a>
                        </div>
                    </div>
                    <div class="dropdown">
                        <button
                            aria-label="Menu."
                            id="menuToobar"
                            data-toggle="dropdown" 
                            aria-haspopup="true" 
                            aria-expanded="false"
                            >
                            <v-icon class="cl-color-white">fas fa-bars</v-icon>
                        </button>
                        <div role="menu" class="dropdown-menu dropdown-menu-right" aria-labelledby="menuToobar">
                            <router-link role="menuitem" class="dropdown-item" aria-label="Home." v-if="login" :to="{name: 'rotas', params: {destino: '@login'}}">
                                <h5 ><v-icon class="pr-2 corIconesToolbar" small>fas fa-home</v-icon> Início</h5>
                            </router-link>
                            <div aria-hidden="true" v-if="login" class="dropdown-divider"></div>
                            <router-link role="menuitem" class="dropdown-item" v-if="!login && !telaGrande" aria-label="Início." :to="{name: 'inicio'}">
                                <h5 class="content-menu"><v-icon class="pr-2 corIconesToolbar" small>fas fa-home</v-icon> Início
                                </h5>
                            </router-link>
                            <div aria-hidden="true" v-if="!login && !telaGrande" class="dropdown-divider"></div>
                            <router-link role="menuitem" class="dropdown-item" v-if="!login && !telaGrande" aria-label="Acordos." :to="{name: 'rotas', params: {destino: '@acordos'}}">
                                <h5 class="content-menu"><v-icon class="pr-3 corIconesToolbar" small>fas fa-file-contract</v-icon>Acordos</h5>
                            </router-link>
                            <div aria-hidden="true" v-if="!login && !telaGrande" class="dropdown-divider"></div>
                            <router-link role="menuitem" class="dropdown-item" v-if="!login && !telaGrande" aria-label="Meus débitos." :to="{name: 'rotas', params: {destino: '@debitos'}}">
                                <h5 class="content-menu"><v-icon class="pr-2 corIconesToolbar" small>fas fa-money-check</v-icon>Meus débitos</h5>
                            </router-link>
                            <!-- <div aria-hidden="true" v-if="!login && !telaGrande" class="dropdown-divider"></div>
                            <a role="menuitem" class="dropdown-item" v-if="!login && !telaGrande" aria-label="Solicitações.">
                                <h5 class="content-menu"><v-icon class="pr-3 corIconesToolbar" small>fas fa-tasks</v-icon>Solicitações</h5>
                            </a> -->
                            <div aria-hidden="true" v-if="!login && !telaGrande" class="dropdown-divider"></div>
                            <router-link role="menuitem" class="dropdown-item"  v-if="!login" aria-label="Cadastro." :to="{name: 'rotas', params: {destino: '@cadastro'}}">
                                <h5><v-icon class="pr-3 corIconesToolbar" small>fas fa-address-book</v-icon>Cadastro</h5>
                            </router-link>
                            <div aria-hidden="true" v-if="!login" class="dropdown-divider"></div>
                            <router-link role="menuitem" class="dropdown-item" aria-label="Como funciona." :to="{name: 'documentosMenu', params: {doc: 'comoFunciona'}}">
                            
                                <h5><v-icon class="pr-3 corIconesToolbar" small>fas fa-question-circle</v-icon>Como funciona</h5>
                            </router-link>
                            <div aria-hidden="true" class="dropdown-divider"></div>
                            <router-link role="menuitem" class="dropdown-item" v-if="login" aria-label="Quem somos." :to="{name: 'documentosMenu', params: {doc: 'quemSomos'}}">
                                <h5><v-icon class="pr-3 corIconesToolbar" small>fas fa-users</v-icon>Quem somos</h5>
                            </router-link>
                            <div aria-hidden="true" v-if="login" class="dropdown-divider"></div>
                            <router-link role="menuitem" class="dropdown-item" aria-label="Contato." :to="{name: 'documentosMenu', params: {doc: 'contato'}}">
                                <h5><v-icon class="pr-3 corIconesToolbar" small>fas fa-phone-square-alt</v-icon>Contato</h5>
                            </router-link>
                            <div aria-hidden="true" class="dropdown-divider" v-if="$route.path!=='/'"></div>
                            <router-link role="menuitem" class="dropdown-item" v-if="$route.path!=='/'" aria-label="Sair." :to="{name: 'login'}">
                                <h5><v-icon class="pr-3 corIconesToolbar" small>fas fa-sign-out-alt</v-icon>Sair</h5>
                            </router-link>
                        </div>
                    </div>
                </div>
             <!--  <h6 v-if="telaGrande" class="mt-4 cl-color-white" style="margin-bottom: -10px">{{empresa}}</h6>--> 
            </div>
        </v-toolbar>
         <!-- <a id="linkF" tabindex="-1" href="https://docs.wixstatic.com/ugd/bad691_3ccc03db531a4ae681b0b02d129cac5a.pdf" aria-hidden="true"  target="_blank"></a> -->
    </div>
</template>
<script>
import Vuex from '@/vuex/store'
import { getEmpresa } from '@/service/service_autoatendimento/rotinas'
import { getLogo, getLogoAdaptor } from '@/service/service_autoatendimento/autoatendimentoconfiguracao'
export default {
    data(){
        return {
            empresa: '',
            logo: "",
            showLogoAdaptor: false
        }
    },
    mounted() {
        setTimeout(() => {
            getEmpresa().then(response => {
                this.empresa = response.data.Retorno
            })
            this.carregaLogo()
            this.carregaLogoAdaptor()
        }, 200)
        this.$mousetrap.bind('ctrl+shift+1', this.loadInicio);
        this.$mousetrap.bind('ctrl+shift+2', this.loadAcordo);
        this.$mousetrap.bind('ctrl+shift+3', this.loadDebito);
        this.$mousetrap.bind('ctrl+shift+4', this.loadCadastro);
    },
    computed: {
        login(){
            return Vuex.state.login
        },
        telaGrande () {
            return Vuex.state.large
        },
        btnSelecionado () {
            if(this.$route.name === 'inicio') return 1
            if(this.$route.name === 'acordos') return 2
            if(this.$route.name === 'debitos') return 3
            if(this.$route.name === 'cadastro') return 4
            else return 0
        }
    },
    methods: {        
        loadInicio () { this.$router.push({name: 'inicio'})},
        loadAcordo () { this.$router.push({name: 'rotas', params: {destino: '@acordos'}})},
        loadDebito () { this.$router.push({name: 'rotas', params: {destino: '@debitos'}})},
        loadCadastro () { this.$router.push({name: 'cadastro'})},
        mudarFonte(e){
            window.fonte(e)
        },
        toggleContrast(){
            window.toggleContrast()
        },
        async carregaLogo() {
            try {
                let r = await getLogo()
                this.logo = r.data.Retorno
            } catch(e) {
                // console.log(e)
            }
        },
        async carregaLogoAdaptor() {
            try {
                let r = await getLogoAdaptor()
                this.showLogoAdaptor = r.data.Retorno
            } catch(e) {
                // console.log(e)
            }
        }
    },
}
</script>
<style>
.container {
	/* max-width: 420px; */
	/* margin: 0 auto; */
	display: flex;
	/* border: 1px solid #ccc; */
}
.flex-start {
    justify-content: flex-start
}
.flex-center {
	justify-content: center;
}
</style>
